(function () {
    'use strict';

    angular
        .module('app')
        .controller('LinePlanEditController', lController);

    function lController($scope, $rootScope, $filter, $timeout, ImageUrl, $state, $stateParams, $window, LinePlanService, UserService, StatusService, GroupService, WorkflowService, toaster, cfpLoadingBar) {

        var model = this;

        model.LinePlanEdit = '';
        model.LinePlanStatusChange = '';
        model.LinePlanRRAssignment = '';
        model.isReadOnly = false;
        model.statusReadOnly = "";
        model.BriefCreate = "";
        model.settings = {};
        $scope.userPermissionFlag = $rootScope.userPermissions;
        $scope.userId = $rootScope.userId
        $scope.currentUserId = $stateParams.linePlanId;
        $scope.currentUserData = $rootScope.globals.currentUser;
        $scope.currentImageUrl = ImageUrl;
        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }
        
        angular.forEach($rootScope.userPermissions,
            function (userPermissionRow) {
                if (userPermissionRow[0] == 1) {
                    if (userPermissionRow[1] == 1) {
                        model.LinePlanRead = true;
                    }
                    if (userPermissionRow[1] == 2) {
                        model.LinePlanEdit = true;
                        $scope.editMode = true;
                    }
                    if (userPermissionRow[1] == 4) {
                        model.LinePlanStatusChange = true;
                    }
                    if (userPermissionRow[1] == 5) {
                        model.LinePlanRRAssignment = true;
                    }
                    if (userPermissionRow[1] == 7) {
                        model.LinePlanDelete = true;
                    }
                }

                //Check for Brief Create Permission
                if (userPermissionRow[0] == 3) {
                    if (userPermissionRow[1] == 3) {
                        model.BriefCreate = true;
                    }
                }
            });

        

        if (!model.LinePlanRead && !model.LinePLanEdit) {
            $state.go('permissionDenied');
        }

        if ($stateParams.linePlanId == null || $stateParams.linePlanId == -1) {
            $state.go("linePlanList"); return; //If no linePlanID then retrurn to LinePlans default Page
        }

        model.linePlanID = $stateParams.linePlanId;

        /*StatusService.isRecordDeleted(1, model.linePlanID)
            .then(function (response) {
                if (response == true) {
                    toaster.pop({
                        type: 'note',
                        title: 'Line Plan Deleted',
                        body: 'The Line Plan you are trying to access is deleted.',
                        timeout: 5000
                    });
                    $state.go('Search');
                }
            },
                function (error, status) {
                    toaster.pop({
                        type: 'error',
                        title: 'Error',
                        body: 'Please contact your System Administrator.',
                        timeout: 5000
                    });
                    $state.go('Search');
                });*/

        model.settings = { displayTableValue: 0 };
        //LinePlanLaunchDates Table settings
        model.settings1 = { displayLaunchTableValue: 0 };
        model.linePlanHeaderInfo = {};
        model.filterText = "";
        model.subSeasonsData = [];
        model.calendarItemData = [];
        model.calendarItemsToDelete = [];
        //model.groups = [];
        model.dataToValidate = [];
        model.calendarItemData1 = []; model.calendarItemsToDelete1 = [];
        model.linePlanSeasonalPlanningItemsData = [];
        model.linePlanLaunchDatesData = [];

        function getBrandPermissions(brandId) {
            //brand permissions
            if (!$rootScope.brandPermissions)
                return;
            var idx = $rootScope.brandPermissions.map(function (e) { return e.BrandId }).indexOf(brandId);
            if (!$rootScope.brandPermissions[idx].IsAssigned) {
                $state.go('permissionDenied');
                return;
            }
        }

        model.disabled = function (date, mode) {
            var retValue = false;
            try {
                retValue = (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
                if (!retValue) {
                    var dt = $filter('date')(date, "MM/dd/yyyy");
                    angular.forEach(linePlanDisableDates, function (d) {
                        if (d == dt) {
                            retValue = true;
                        }
                    });
                }
            } catch (e) { }
            return retValue;
        };

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        model.View = function () {
            $state.go("linePlan", { linePlanId: model.linePlanID });
        };

        model.GanttView = function () {
            $state.go("linePlanGanttView",
                {
                    linePlanId: model.linePlanID
                });
        };

        model.CreateBrief = function () {
            $state.go("projectCreate", {
                linePlanId: model.linePlanID
            });
        };

        model.List = function () {
            $state.go("linePlanList");
        };

        model.getUser = function ($model) {
            if ($scope.linePlanCalendersForm.$dirty) {
                if (!$model) {
                    var nameCheck = false;
                    $scope.getUserResponse = false;
                    angular.forEach(model.users,
                        function (k) {
                            var name = model.linePlanHeaderInfo.Accountable.FullName
                                ? model.linePlanHeaderInfo.Accountable.FullName.toLowerCase()
                                : model.linePlanHeaderInfo.Accountable.toLowerCase();
                            if (name == k.FullName.toLowerCase() && !nameCheck) {
                                $scope.getUserResponse = true;
                                model.linePlanHeaderInfo.ResponsibleId = k.Id;
                                model.linePlanHeaderInfo.Accountable = k.FullName; //assign name
                                nameCheck = true;
                            }
                        });
                } else {
                    $scope.getUserModel = $model;
                    //assign responsible id
                    model.linePlanHeaderInfo.ResponsibleId = $scope.getUserModel.Id;
                    $scope.getUserResponse = true;
                }
                model.validateUser();
            }
        };

        model.validateUser = function () {
            $timeout(function () {
                    if ($scope.getUserResponse) {
                        $scope.linePlanCalendersForm.rrAssignment.$setValidity('accountableName', true);
                    } else {
                        $scope.linePlanCalendersForm.rrAssignment.$setValidity('accountableName', false);
                    }
                },
                100);
        };

        model.checkLinePlanName = function (scope) {
            //scope.linePlanCalendersForm.LinePlanName.$setValidity('linePlanNameExists', true);
            var linePlanName = model.linePlanHeaderInfo.LinePlanName;
            toaster.clear();
            LinePlanService.isLinePlanNameExists(model.linePlanID,
                    linePlanName,
                    model.linePlanHeaderInfo.BrandId,
                    model.linePlanHeaderInfo.SeasonId)
                .then(function (response) {
                    if (response == true) {
                        //scope.linePlanCalendersForm.LinePlanName.$setValidity('linePlanNameExists', false);
                        toaster.pop({
                            type: 'note',
                            title: 'Name duplication',
                            body: 'You may continue, but please note this name already exists.',
                            timeout: 5000
                        });
                    }
                });
        };

        model.Save = function (isFormInvalid) {
            if (!isFormInvalid) {
                var changesMade = $scope.linePlanCalendersForm.$dirty;
                $scope.linePlanCalendersForm.$setPristine();
                var accountableId = model.linePlanHeaderInfo.ResponsibleId;
                var statusId = model.linePlanHeaderInfo.StatusId;
                var wfGroupId = model.linePlanHeaderInfo.WFGroupId;
                if (model.LinePlanRRAssignment) {
                    if (model.linePlanHeaderInfo.Accountable.Id) {
                        accountableId = model.linePlanHeaderInfo.Accountable.Id;
                    }
                }

                if (model.LinePlanStatusChange) {
                    statusId = model.linePlanHeaderInfo.StatusId;
                }

                //alert(accountableId);
                if (accountableId == 'undefined' || accountableId != null || accountableId != "") {

                    model.linePlanData = {
                        LinePlanId: model.linePlanID,
                        LinePlanName: model.linePlanHeaderInfo.LinePlanName,
                        StatusId: statusId,
                        ResponsibleId: accountableId,
                        IsLocked: model.linePlanHeaderInfo.IsLocked,
                        WFGroupId: wfGroupId,
                        ChangesMade: changesMade
                    };

                    var getAdoptionDueDate = "";
                    var getSpecLockDueDate = "";
                    var getPoIssuedDate = "";
                    var getT2DueDate = "";
                    var getT3DueDate = "";
                    var getFactoryExGoDate = "";
                    var getAvailAtRetailDate = "";

                    //Get LaunchDates subseason 1 data
                    for (var e = 0; e < model.dataLaunch0.length; e++) {
                        getAdoptionDueDate = "";
                        getSpecLockDueDate = "";
                        getPoIssuedDate = "";
                        getT2DueDate = "";
                        getT3DueDate = "";
                        getFactoryExGoDate = "";
                        getAvailAtRetailDate = "";

                        if (model.dataLaunch0[e].AdoptionDueDate) {
                            var adoptionDueDate = new Date(model.dataLaunch0[e].AdoptionDueDate);

                            // After this construct a string with the above results as below
                            getAdoptionDueDate = $filter('date')(adoptionDueDate, 'short');
                        }

                        if (model.dataLaunch0[e].SpecLckT1DueDate) {
                            var specLockDueDate = new Date(model.dataLaunch0[e].SpecLckT1DueDate);

                            // After this construct a string with the above results as below
                            getSpecLockDueDate = $filter('date')(specLockDueDate, 'short');
                        }

                        if (model.dataLaunch0[e].PoIssuedDate) {
                            var poIssuedDate = new Date(model.dataLaunch0[e].PoIssuedDate);

                            // After this construct a string with the above results as below
                            getPoIssuedDate = $filter('date')(poIssuedDate, 'short');
                        }

                        if (model.dataLaunch0[e].T2DueDate) {
                            var t2DueDate = new Date(model.dataLaunch0[e].T2DueDate);

                            // After this construct a string with the above results as below
                            getT2DueDate = $filter('date')(t2DueDate, 'short');
                        }

                        if (model.dataLaunch0[e].T3DueDate) {
                            var t3DueDate = new Date(model.dataLaunch0[e].T3DueDate);

                            // After this construct a string with the above results as below
                            getT3DueDate = $filter('date')(t3DueDate, 'short');
                        }

                        if (model.dataLaunch0[e].FactoryExGoDate) {
                            var factoryExGoDate = new Date(model.dataLaunch0[e].FactoryExGoDate);

                            // After this construct a string with the above results as below
                            getFactoryExGoDate = $filter('date')(factoryExGoDate, 'short');
                        }

                        if (model.dataLaunch0[e].AvailAtRetailDate) {
                            var availAtRetailDate = new Date(model.dataLaunch0[e].AvailAtRetailDate);

                            // After this construct a string with the above results as below
                            getAvailAtRetailDate = $filter('date')(availAtRetailDate, 'short');
                        }

                        model.linePlanLaunchDatesData.push({
                            LinePlanLaunchDateId: model.dataLaunch0[e].LinePlanLaunchDateId,
                            AdoptionDueDate: getAdoptionDueDate,
                            SpecLckT1DueDate: getSpecLockDueDate,
                            PoIssuedDate: getPoIssuedDate,
                            T2DueDate: getT2DueDate,
                            T3DueDate: getT3DueDate,
                            FactoryExGoDate: getFactoryExGoDate,
                            AvailAtRetailDate: getAvailAtRetailDate
                        });

                    }

                    //get Launch Dates subseason 2 data
                    for (var f = 0; f < model.dataLaunch1.length; f++) {
                        getAdoptionDueDate = "";
                        getSpecLockDueDate = "";
                        getPoIssuedDate = "";
                        getT2DueDate = "";
                        getT3DueDate = "";
                        getFactoryExGoDate = "";
                        getAvailAtRetailDate = "";

                        if (model.dataLaunch1[f].AdoptionDueDate) {
                            var adoptionDueDate = new Date(model.dataLaunch1[f].AdoptionDueDate);

                            // After this construct a string with the above results as below
                            getAdoptionDueDate = $filter('date')(adoptionDueDate, 'short');
                        }

                        if (model.dataLaunch1[f].SpecLckT1DueDate) {
                            var specLockDueDate = new Date(model.dataLaunch1[f].SpecLckT1DueDate);

                            // After this construct a string with the above results as below
                            getSpecLockDueDate = $filter('date')(specLockDueDate, 'short');
                        }

                        if (model.dataLaunch1[f].PoIssuedDate) {
                            var poIssuedDate = new Date(model.dataLaunch1[f].PoIssuedDate);

                            // After this construct a string with the above results as below
                            getPoIssuedDate = $filter('date')(poIssuedDate, 'short');
                        }

                        if (model.dataLaunch1[f].T2DueDate) {
                            var t2DueDate = new Date(model.dataLaunch1[f].T2DueDate);

                            // After this construct a string with the above results as below
                            getT2DueDate = $filter('date')(t2DueDate, 'short');
                        }

                        if (model.dataLaunch1[f].T3DueDate) {
                            var t3DueDate = new Date(model.dataLaunch1[f].T3DueDate);

                            // After this construct a string with the above results as below
                            getT3DueDate = $filter('date')(t3DueDate, 'short');
                        }

                        if (model.dataLaunch1[f].FactoryExGoDate) {
                            var factoryExGoDate = new Date(model.dataLaunch1[f].FactoryExGoDate);

                            // After this construct a string with the above results as below
                            getFactoryExGoDate = $filter('date')(factoryExGoDate, 'short');
                        }

                        if (model.dataLaunch1[f].AvailAtRetailDate) {
                            var availAtRetailDate = new Date(model.dataLaunch1[f].AvailAtRetailDate);

                            // After this construct a string with the above results as below
                            getAvailAtRetailDate = $filter('date')(availAtRetailDate, 'short');
                        }

                        model.linePlanLaunchDatesData.push({
                            LinePlanLaunchDateId: model.dataLaunch1[f].LinePlanLaunchDateId,
                            AdoptionDueDate: getAdoptionDueDate,
                            SpecLckT1DueDate: getSpecLockDueDate,
                            PoIssuedDate: getPoIssuedDate,
                            T2DueDate: getT2DueDate,
                            T3DueDate: getT3DueDate,
                            FactoryExGoDate: getFactoryExGoDate,
                            AvailAtRetailDate: getAvailAtRetailDate
                        });
                    }

                    LinePlanService.updateLinePlan(model.linePlanData, model.linePlanLaunchDatesData)
                        .then(function (response) {
                            },
                            function (error, status) {
                            });
                } else {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'User Id is missing',
                        timeout: 5000
                    });
                }

                //Save Line Plan Seasonal Planning Items Data
                for (var l = 0; l < model.linePlanSeasonalPlanningItems.length; l++) {
                    var getStartDate = "";
                    var getEndDate = "";

                    if (model.linePlanSeasonalPlanningItems[l].StartDate) {
                        var startDate = new Date(model.linePlanSeasonalPlanningItems[l].StartDate);

                        // After this construct a string with the above results as below
                        getStartDate = $filter('date')(startDate, 'short');
                    }

                    if (model.linePlanSeasonalPlanningItems[l].EndDate) {

                        var endDate = new Date(model.linePlanSeasonalPlanningItems[l].EndDate);
                        // After this construct a string with the above results as below
                        getEndDate = $filter('date')(endDate, 'short');
                    }

                    model.linePlanSeasonalPlanningItemsData.push({
                        LinePlanSeasonalPlanningItemId: model.linePlanSeasonalPlanningItems[l]
                            .LinePlanSeasonalPlanningItemId,
                        StartDate: getStartDate,
                        EndDate: getEndDate
                    });
                }

                LinePlanService.updateLinePlanSeasonalPlanningItems(model.linePlanSeasonalPlanningItemsData)
                    .then(function (response) {
                            //$state.go("linePlan", { linePlanId: model.linePlanID });
                        },
                        function (error, status) {
                        });

                //array for data
                model.dataFunction = function (a, a2, caltoupdate) {
                    angular.forEach(a,
                        function (k) {
                            var getStartDate = "";
                            var getEndDate = "";

                            if (k.StartDate) {
                                var startDate = new Date(k.StartDate);
                                // After this construct a string with the above results as below
                                getStartDate = $filter('date')(startDate, 'short');
                            };

                            if (k.EndDate) {
                                var endDate = new Date(k.EndDate);
                                // After this construct a string with the above results as below
                                getEndDate = $filter('date')(endDate, 'short');
                            }

                            var depId = "";

                            //The API Model does not handle null values for integers, so initialize dependency vlaue to "" and assign value if present
                            //if (k.DependentItemId != null) {
                            //    depId = k.DependentItemId;
                            //}

                            var calid = model.subSeason1CalendarId; //default 
                            if (caltoupdate == 1) {
                                calid = model.subSeason1CalendarId;
                            }
                            else if (caltoupdate == 2) {
                                calid = model.subSeason2CalendarId;
                            }

                            a2.push({
                                CalendarItemId: k.CalendarItemId,
                                CalendarId: calid,
                                Name: k.Name,
                                Stage: k.Stage,
                                StartDate: getStartDate,
                                EndDate: getEndDate,
                                GroupId: k.GroupId,
                                Sort: k.Sort,
                                IsDelete: 0
                            });

                        });
                    $scope.$evalAsync();
                };

                model.dataFunction($scope.calendar1, model.calendarItemData, 1);
                model.dataFunction($scope.calendar2, model.calendarItemData1, 2);

                for (var j = 0; j < model.calendarItemsToDelete.length; j++) {
                    model.calendarItemData.push({
                        CalendarItemId: model.calendarItemsToDelete[j].CalendarItemId,
                        CalendarId: model.subSeason1CalendarId,
                        Name: "",
                        Stage: "",
                        StartDate: "",
                        EndDate: "",
                        Sort: 0,
                        IsDelete: 1
                    });
                }

                //save $scope.calendar1
                LinePlanService.saveCalendarItems(model.calendarItemData)
                    .then(function (response) {
                            //$state.go("linePlan", { linePlanId: model.linePlanID });

                            for (var j = 0; j < model.calendarItemsToDelete1.length; j++) {
                                model.calendarItemData1.push({
                                    CalendarItemId: model.calendarItemsToDelete1[j].CalendarItemId,
                                    CalendarId: model.subSeason2CalendarId,
                                    Name: "",
                                    Stage: "",
                                    StartDate: "",
                                    EndDate: "",
                                    Sort: 0,
                                    IsDelete: 1
                                });
                            }

                            LinePlanService.saveCalendarItems(model.calendarItemData1)
                            .then(function (response) {

                                        model.linePlanHeaderInfo = {};
                                        model.filterText = "";
                                        model.subSeasonsData = [];
                                        model.calendarItemData = [];
                                        model.calendarItemsToDelete = [];
                                        model.dataToValidate = [];
                                        model.calendarItemData1 = [];
                                        model.calendarItemsToDelete1 = [];

                                        init();

                                        $scope.linePlanCalendersForm.$setPristine();
                                        $scope.linePlanCalendersForm.$setUntouched();
                                        //getLinePlanHeaderInformation();
                                        toaster.pop({
                                            type: 'success',
                                            title: 'Success!',
                                            body: 'Record Saved Successfully.',
                                            timeout: 5000
                                        });

                                    },
                                function (error, status) {
                                        toaster.pop({
                                            type: 'error',
                                            title: 'Error!',
                                            body:
                                                'There was an error while saving the record. Please contact system administrator',
                                            timeout: 5000
                                        });
                                        $scope.linePlanCalendersForm.$setPristine();
                                        $scope.linePlanCalendersForm.$setUntouched();
                                        //console.log(error);
                                    });

                        },
                        function (error, status) {
                            //console.log(error);
                            //console.log(status);
                        });


                if (changesMade) {
                    WorkflowService.logDataChangedEvent(1, model.linePlanHeaderInfo.LinePlanId);
                }
            } else {
                var dtv = model.settings.displayTableValue;
                var validationArr = [];

                if (dtv !== -1 && model.linePlanHeaderInfo.StatusId == 2) {
                    var f0, f1, f2;
                    angular.forEach($scope.linePlanCalendersForm.$error.required,
                        function (k, v) {
                            if (k.$name == 'linePlanSeasonalForm') {
                                f0 = true;
                            }
                            if (k.$name == 'linePlanForm') {
                                f1 = true;
                            }
                            if (k.$name == 'linePlanForm1') {
                                f2 = true;
                            }

                            if (validationArr.indexOf(k.$name) == -1) {
                                validationArr.push(k.$name);
                            }
                        });
                }

                angular.forEach($scope.linePlanCalendersForm.$error,
                    function (k, v) {
                        var key = v;
                        var arr = $scope.linePlanCalendersForm.$error[key];

                        angular.forEach(arr,
                            function (k, v) {
                                if (validationArr.length == 0) {
                                    //var first = document.querySelector('input.ng-invalid').getBoundingClientRect();
                                    //$("body").animate({ scrollTop: first.top-325 }, "slow");

                                    //$timeout(function () {
                                    //    var test = document.querySelector('input.ng-invalid');
                                    //    console.log(test);
                                    //})
                                }
                                if (k.$name == 'linePlanSeasonalForm') {
                                    f0 = true;
                                }
                                if (k.$name == 'linePlanForm') {
                                    f1 = true;
                                }
                                if (k.$name == 'linePlanForm1') {
                                    f2 = true;
                                }

                                if (validationArr.indexOf(k.$name) == -1) {
                                    validationArr.push(k.$name);
                                }
                            });

                    });

                if (validationArr.length > 0) {
                    var text = '';
                    if (f0) {
                        text += 'Seasonal Planning Phase';
                    }
                    if (f1) {
                        if (text !== '') text += ', ';
                        text += "Calendar" + (f2 ? 's: ' : ': ') + model.subSeason1;
                    }
                    if (f2) {
                        if (text !== '') {
                            text += " & ";
                        }
                        text += ' ' + model.subSeason2;
                    }
                    toaster.clear();
                    toaster.pop({
                        type: 'error',
                        title: 'Errors found.',
                        body: 'Details Tab > ' + text,
                        timeout: 10000
                    });
                }

            }
        };

        model.CalenderView = function () {
            $state.go("linePlan", { linePlanId: model.linePlanID });
        };

        model.addRow = function (idx, a, t) {
            var arr;
            if (t == 'sortableTable1') {
                arr = $scope.calendar1;
            }

            if (t == 'sortableTable2') {
                arr = $scope.calendar2;
            }

            var item = {
                CalendarItemId: 0,
                Sort: idx + 10 + a,
                CalendarItemTypeId: 1,
                Stage: "",
                Name: "",
                StartDate: "",
                EndDate: "",
                GroupName: "",
                isEdit: true
            };
            arr.splice(idx + a, 0, item);
            var e = document.getElementById(t);
            //$scope.focusElement = e.children[idx+(a=0 ? -1 : 1)];
            //$scope.focusElement = undefined;
            $scope.reIndexSort(arr);
        };

        model.CancelRow = function (currentIndex, arr) {
            if ($window.confirm("This action will delete the current row. Do you want to continue?")) {
                //mark row to delete from database only if calendar item id exists
                if (arr[currentIndex].CalendarItemId != 0) {
                    model.calendarItemsToDelete.push({
                        CalendarItemId: arr[currentIndex].CalendarItemId,
                        CalendarId: arr[currentIndex].CalendarId
                    });
                }
                arr.splice(currentIndex, 1);
            }
            $scope.tableOrder(currentIndex, false, arr);
        };
        
        model.export = function () {

            var planningItemsData = _.map(model.linePlanSeasonalPlanningItems, mapPlanningItemData);
            
            var cal1Data = _.map($scope.calendar1, mapCalExportData);

            var cal2Data = _.map($scope.calendar2, mapCalExportData);

            var combinedLaunchDates = [].concat(model.dataLaunch0, model.dataLaunch1);

            var launchDatesData = _.map(combinedLaunchDates, mapLaunchDateExportData);

            var headerInfo = mapHeaderInfo(model.linePlanHeaderInfo);

            var sheets = [
                { sheetid: 'Line Plan', header: true },
                { sheetid: 'Seasonal Planning Phase', header: true },
                { sheetid: 'Calendar ' + model.subSeason1, header: true },
                { sheetid: 'Calendar ' + model.subSeason2, header: true },
                { sheetid: 'Launch Dates ' + model.subSeason1 + ' and ' + model.subSeason2, header: true }
            ];

            alasql.promise('SELECT INTO XLSX("LinePlanExport.xlsx",?) FROM ?', [sheets, [headerInfo, planningItemsData, cal1Data, cal2Data, launchDatesData]])
                .then(function () {
                    cfpLoadingBar.complete();
                });
        };

        function formatExportDate(value) {
            return value ? moment(new Date(value)).format('L') : '';
        }

        function formatDuration(value) {
            return value && value > 0 ? value : '';
        }

        function mapPlanningItemData(k) {
            return {
                "Name": k.Name,
                "Start Date": formatExportDate(k.StartDate),
                "End Date": formatExportDate(k.EndDate),
                "Group": k.GroupName
            };
        }

        function mapCalExportData(k) {
            return {
                "Order": k.Sort,
                "Stage": k.Stage,
                "Name": k.Name,
                "Start Date": formatExportDate(k.StartDate),
                "End Date": formatExportDate(k.EndDate),
                "Duration": formatDuration(k.Duration),
                "Group": k.GroupName
            };
        }

        function mapLaunchDateExportData(k) {
            return {
                "Launch ID": k.LinePlanLaunchDateId,
                "Launch": k.LaunchNumDesc,
                "Adoption Due Date": formatExportDate(k.AdoptionDueDate),
                "Spec Lock/T1 Due Date": formatExportDate(k.SpecLckT1DueDate),
                "PO's Issued Date": formatExportDate(k.PoIssuedDate),
                "T2 Due Date": formatExportDate(k.T2DueDate),
                "T3 Due Date": formatExportDate(k.T3DueDate),
                "Factory Ex-Go Date": formatExportDate(k.FactoryExGoDate),
                "Available @ Retail": formatExportDate(k.AvailAtRetailDate)
            };
        }

        function mapHeaderInfo(k) {
            return [
                {
                    "Line Plan Id": k.LinePlanId,
                    "Name": k.LinePlanName,
                    "Season": k.SeasonName,
                    "Brand": k.BrandName
                }
            ];
        }

        function getUsers() {
            UserService.getUsersByBrand(model.linePlanHeaderInfo.BrandId).then(function (data) {
                model.users = data;
            });
        }

        function getWFGroups(brandId) {
            WorkflowService.getWFGroups(model.linePlanHeaderInfo.BrandId, 1).then(function (data) {
                model.wfGroups = data;
            });
        }

        function getStatusList(currentStatusId) {
            StatusService.getAvailableStatusList(currentStatusId).then(function (data) {
                model.statusList = data;
            });
        }

        function setImportButtonVisibility(statusId) {
            switch (statusId) {
                case 1:
                case 2:
                    model.showImportButton = true;
                    break;
                default:
                    model.showImportButton = false;
                    break;
            }
        }

        function getGroupList() {
            GroupService.getGroupList().then(function (groupResponse) {
                model.groups = groupResponse;
            });
        }

        $scope.checkSeasonList = function (seasonList) {
            var length = seasonList.length - 1;
            if (model.linePlanHeaderInfo.SeasonName == seasonList[length].SeasonName) {
                return true;
            }
        };

        function getLinePlanHeaderInformation() {
          /*  LinePlanService.getLinePlanHeaderInfo(model.linePlanID)
                .then(function (response) {
                    //if (response === null) {
                    //    $state.go('permissionDenied');
                    //    return;
                    //}

                    model.linePlanHeaderInfo = response;

                    getBrandPermissions(model.linePlanHeaderInfo.BrandId);

                    var statusId = model.linePlanHeaderInfo.StatusId;

                    model.linePlanCurrStatusId = statusId;

                    if (statusId == 3 || statusId == 4 || statusId == 5 || statusId == 6 || statusId == 7 || model.linePlanHeaderInfo.IsDeleted == true) {
                        model.isReadOnly = true;
                    }
                    else {
                        model.isReadOnly = false;
                    }

                    getUsers();
                    setImportButtonVisibility(statusId);
                    getStatusList(statusId);
                    getGroupList();
                    getWFGroups();

                    if (statusId == 1) {
                        //Check if there are any briefs associated with this line to manage Delete option
                        if (model.linePlanHeaderInfo.IsDeleted == true) {
                            model.LinePlanDelete = false;
                        }
                        else {
                            LinePlanService.getLinePlanBriefs(model.linePlanID).then(function (linePlanBriefsResponse) {
                                if (linePlanBriefsResponse && linePlanBriefsResponse.length != 0) {
                                    model.LinePlanDelete = false;
                                }
                            },
                                function (error, status) {
                                    model.LinePlanDelete = false;
                                });
                        }
                    }
                    else {
                        model.LinePlanDelete = false;
                    }


                    //log to last used
                    var lastUsedModel = {
                        UserId: $rootScope.userId,
                        ProjectId: model.linePlanHeaderInfo.LinePlanId,
                        ProjectLevelId: 1,
                    };
                    UserService.logLastUseProject(lastUsedModel);
                });*/
        }

        function getLinePlanSeasonalPlanningItems() {
            /*LinePlanService.getLinePlanSeasonalPlanningItems(model.linePlanID).then(function (lpspResponse) {
                model.linePlanSeasonalPlanningItems = lpspResponse;
                angular.forEach(model.linePlanSeasonalPlanningItems, function (k) {
                    k.StartDate = $filter('date')(k.StartDate, "MM/dd/yyyy");
                    k.EndDate = $filter('date')(k.EndDate, "MM/dd/yyyy");
                });
            });*/
        }

        function getLinePlanSubSeasons() {
           /* LinePlanService.getLinePlanSubSeasons(model.linePlanID).then(function (subSeasonsResponse) {
                angular.forEach(subSeasonsResponse, function (subSeasonsRow, $index) {
                    model.subSeasonsData.push({
                        'subSeasonId': subSeasonsRow.SubSeasonId, 'subSeasonName': subSeasonsRow.Name, 'calendarId': subSeasonsRow.CalendarId
                    });

                    if ($index == '0') {
                        model.subSeason1 = subSeasonsRow.Name;
                        model.subSeason1CalendarId = subSeasonsRow.CalendarId;
                        model.subSeason1EndDate = subSeasonsRow.EndDate;
                    }
                    else {
                        model.subSeason2 = subSeasonsRow.Name;
                        model.subSeason2CalendarId = subSeasonsRow.CalendarId;
                        model.subSeason2EndDate = subSeasonsRow.EndDate;
                    }

                    //Get linePlan items
                    LinePlanService.getLinePlanCalendarItems(subSeasonsRow.CalendarId).then(function (response) {
                        if ($index == '0') {
                            $scope.calendar1 = response;
                            angular.forEach($scope.calendar1, function (k) {
                                k.StartDate = $filter('date')(k.StartDate, "MM/dd/yyyy");
                                k.EndDate = $filter('date')(k.EndDate, "MM/dd/yyyy");
                            });
                        } else {
                            $scope.calendar2 = response;
                            angular.forEach($scope.calendar2, function (k) {
                                k.StartDate = $filter('date')(k.StartDate, "MM/dd/yyyy");
                                k.EndDate = $filter('date')(k.EndDate, "MM/dd/yyyy");
                            });
                        }

                        //Start Date and EndDate required to be Date object format
                        angular.forEach(response, function (item) {
                            if (item.StartDate !== '' && item.EndDate !== '' && item.StartDate !== null && item.EndDate !== null) {
                                item.StartDate = $filter('date')(item.StartDate, "MM/dd/yyyy");
                                item.EndDate = $filter('date')(item.EndDate, "MM/dd/yyyy");
                                var date1 = new Date(item.StartDate);
                                var date2 = new Date(item.EndDate);
                                var timeDiff = Math.abs(date2.getTime() - date1.getTime());
                                var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
                                item.Duration = diffDays;
                            };
                        });
                    });

                    //Get linePlan LaunchDates
                    LinePlanService.getLinePlanLaunchDates(subSeasonsRow.CalendarId).then(function (response) {
                        if ($index == '0') {
                            model.dataLaunch0 = response;
                        } else {
                            model.dataLaunch1 = response;
                        }
                        if (!response) {
                            model["dataLaunchResponse" + $index] = "";
                        }
                        else {
                            model["dataLaunchResponse" + $index] = "data";
                        }
                    });


                });
            }, function () {
            });*/
        }

        function init() {
            getLinePlanHeaderInformation();
            getLinePlanSeasonalPlanningItems();
            getLinePlanSubSeasons();
        }

        init();

        $scope.tableOrder = function (n, o, arr, e) {

            if (arr == 'sortableTable1') {
                arr = $scope.calendar1;
            }

            if (arr == 'sortableTable2') {
                arr = $scope.calendar2;
            }

            var currentObject = arr[o];

            if (n !== arr[o].SortOriginal) {

                //if on blur
                //line up what was input(n) and object sort
                if (e) {
                    $scope.focusElement = e.target;
                    var newArr = arr.slice(0);
                    newArr.sort(function (a, b) {
                        return a.Sort - b.Sort;
                    });
                    var getNewIndex;
                    //loop through to get new index
                    angular.forEach(newArr,
                        function (k, v) {
                            if (currentObject == k) {
                                n = v;
                            }
                        });
                }

                //actually moving the index on drag...
                arr.splice(o, 1);
                arr.splice(n, 0, currentObject);
                $scope.reIndexSort(arr);

                model.setIndexId(n);

                if (typeof $scope.focusElement !== 'undefined') {
                    $scope.focusElement.focus();
                }
            }
        };

        $scope.reIndexSort = function (arr) {
            angular.forEach(arr,
                function (k, v) {
                    v++;
                    k.Sort = v * 10;
                    k.SortOriginal = v * 10;
                });
        };

        $scope.tableOrderKey = function (event, $index, array) {

            if (array == 'sortableTable1') {
                array = $scope.calendar1;
            }

            if (array == 'sortableTable2') {
                array = $scope.calendar2;
            }
            //backspace, tab, up, down, left, right arrows, enter
            var allowedKeys = [8, 9, 13, 37, 38, 39, 40, 46, 116];
            var allowedMetaKeys = [65, 86, 67, 88, 82, 90];
            //Ctrl, Ctrl + A, Ctrl + C, Ctrl + V, Ctrl + X, Ctrl + R, Ctrl + Z
            var eventKey = event.key;

            //no spacebar
            if (eventKey == " ") {
                eventKey = 'x';
                //just defaulting it to a value that isnt allowed
            }

            if (isNaN(eventKey) && eventKey !== 'Tab') {
                //if ctrl isnt being pressed
                var ctrlMeta = event.ctrlKey == true || event.metaKey == true;
                if (ctrlMeta) {
                    //move to first
                    if (event.keyCode == 38) {
                        $scope.tableOrder(0, $index, array, null);
                        $scope.focusElement = event.path[2].children[0];
                    }
                    //move to last
                    if (event.keyCode == 40) {
                        $scope.tableOrder(array.length - 1, $index, array, null);
                        $scope.focusElement = event.path[2].children[array.length - 1];
                    }
                } else {
                    if (allowedKeys.indexOf(event.keyCode) == -1) {
                        event.preventDefault();
                    }
                    if (allowedMetaKeys.indexOf(event.keyCode) > -1) {
                        event.preventDefault();
                    }

                    //move up 1
                    if (event.keyCode == 38) {
                        if ($index !== 0) {
                            $scope.focusElement = event.path[2].children[$index];
                            $scope.tableOrder($index - 1, $index, array, null);
                        }
                    }

                    //move down 1
                    if (event.keyCode == 40) {
                        if ($index !== array.length - 1) {
                            $scope.tableOrder($index + 1, $index, array, null);
                        }
                    }
                }
            }
        };

        //default sort order set to false (desc) so when you first click, its asc
        $scope.tableSortDir = '';
        $scope.tableSort = function (h) {
            if (h !== $scope.tableSortName) {
                //reset order direction if new name is chosen
                $scope.tableSortDir = '';
            }

            $scope.tableSortName = h;

            if ($scope.tableSortDir === '') { //first click
                $scope.tableSortDir = false;
                $scope.tableSortClass = 'fa-caret-up';
            } else if ($scope.tableSortDir === false) { //second click
                $scope.tableSortDir = true;
                $scope.tableSortClass = 'fa-caret-down';
            } else { //third click, reset it all
                $scope.tableSortDir = '';
                $scope.tableSortClass = '';
                $scope.tableSortName = '';
            }
        };

        //Set Selected Row
        model.setIndexId = function (currentIndex) {
            model.indexId = currentIndex;
        };

        model.populateDates = function (t) {
            var arrays = [
                $scope.calendar1,
                $scope.calendar2
            ];

            for (var i = 0; i < arrays.length; i++) {
                var arr = arrays[i];

                angular.forEach(arr,
                    function (k) {
                        var date = $filter('date')(new Date(), "MM/dd/yyyy");

                        if (k.StartDate == null || k.StartDate == '' || k.StartDateOriginal === false) {
                            k.StartDateOriginal = false; //bind original start date
                            if (t) k.StartDate = date;
                            else if (!t && k.StartDateOriginal === false) k.StartDate = null;

                        };
                        if (k.EndDate == null || k.EndDate == '' || k.EndDateOriginal === false) {
                            k.EndDateOriginal = false; //bind original end date
                            if (t) k.EndDate = date;
                            else if (!t && k.EndDateOriginal === false) k.EndDate = null;
                        }
                    });
            }


        };

        function formatString(format) {
            var day = parseInt(format.substring(3, 5));
            var month = parseInt(format.substring(0, 2));
            var year = parseInt(format.substring(6, 10));
            var date = new Date(year, month - 1, day);
            return date;
        }

        model.validateSeasonalDate = function (scope, currentIndex, dateField) {

            var sd = model.linePlanSeasonalPlanningItems[currentIndex].StartDate || '';
            var ed = model.linePlanSeasonalPlanningItems[currentIndex].EndDate || '';
            if (sd !== '' && ed !== '') {

                scope.linePlanSeasonalForm.startdate.$setValidity('sDate', true);
                scope.linePlanSeasonalForm.enddate.$setValidity('eDate', true);

                var currentStartDate = $filter('date')(model.linePlanSeasonalPlanningItems[currentIndex].StartDate,
                    "MM/dd/yyyy");
                var currentEndDate = $filter('date')(model.linePlanSeasonalPlanningItems[currentIndex].EndDate,
                    "MM/dd/yyyy");

                var date2 = new Date(formatString(currentEndDate));
                var date1 = new Date(formatString(currentStartDate));

                if (date2.getTime() - date1.getTime() >= 0) {
                    scope.linePlanSeasonalForm.startdate.$setValidity('sDate', true);
                    scope.linePlanSeasonalForm.enddate.$setValidity('eDate', true);
                } else {
                    if (dateField == 's') {
                        scope.linePlanSeasonalForm.startdate.$setValidity('sDate', false);
                    } else if (dateField == 'e') {
                        scope.linePlanSeasonalForm.enddate.$setValidity('eDate', false);
                    }
                }
            } else {
                $scope.linePlanCalendersForm.linePlanSeasonalForm.$invalid = true;
            }

        };

        model.updateTable1 = function (scope, currentIndex, dateField) {
            var sd = scope.item.StartDate || '';
            var ed = scope.item.EndDate || '';
            if (sd !== '' && ed !== '') {
                var currentStartDate = $filter('date')($scope.calendar1[currentIndex].StartDate, "MM/dd/yyyy");
                var currentEndDate = $filter('date')($scope.calendar1[currentIndex].EndDate, "MM/dd/yyyy");

                var date1 = new Date(currentStartDate);
                var date2 = new Date(currentEndDate);

                if (date2.getTime() - date1.getTime() >= 0) {
                    scope.linePlanForm.startdate.$setValidity('sDate', true);
                    scope.linePlanForm.enddate.$setValidity('eDate', true);
                    var timeDiff = Math.abs(date2.getTime() - date1.getTime());
                    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
                    $scope.calendar1[currentIndex].Duration = diffDays;
                } else {
                    $scope.calendar1[currentIndex].Duration = 0;
                    if (dateField == 'e') {
                        scope.linePlanForm.enddate.$setValidity('eDate', false);
                    } else {
                        scope.linePlanForm.startdate.$setValidity('sDate', false);
                    }

                }
            } else {
                //$scope.linePlanCalendersForm.linePlanForm.$invalid = true;
            }
        };

        model.updateTable2 = function (scope, currentIndex, dateField) {
            var sd = scope.item.StartDate || '';
            var ed = scope.item.EndDate || '';
            if (sd !== '' && ed !== '') {

                var currentStartDate = $filter('date')($scope.calendar2[currentIndex].StartDate, "MM/dd/yyyy");
                var currentEndDate = $filter('date')($scope.calendar2[currentIndex].EndDate, "MM/dd/yyyy");

                var date1 = new Date(currentStartDate);
                var date2 = new Date(currentEndDate);

                if (date2.getTime() - date1.getTime() >= 0 &&
                    scope.item.StartDate !== '' &&
                    scope.item.EndDate !== '') {
                    scope.linePlanForm1.startdate.$setValidity('sDate', true);
                    scope.linePlanForm1.enddate.$setValidity('eDate', true);
                    var timeDiff = Math.abs(date2.getTime() - date1.getTime());
                    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

                    $scope.calendar2[currentIndex].Duration = diffDays;
                } else {
                    $scope.calendar2[currentIndex].Duration = 0;
                    if (dateField == 'e') {
                        scope.linePlanForm1.enddate.$setValidity('eDate', false);
                    } else {
                        scope.linePlanForm1.startdate.$setValidity('sDate', false);
                    }
                }
            } else {
                $scope.linePlanCalendersForm.linePlanForm1.$invalid = true;
            }
        };

        model.deleteLinePlan = function () {
            LinePlanService.deleteLinePlan(model.linePlanID).then(function (deleteLinePlanResponse) {
                    toaster.pop({
                        type: 'success',
                        title: 'Success!',
                        body: 'Record Deleted Successfully.',
                        timeout: 5000
                    });
                    $state.go('Search');
                    //getLinePlanHeaderInformation();
                },
                function (error, status) {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'There was an error while deleting the record. Please contact your administrator.',
                        timeout: 5000
                    });
                }
            );
        };

        $scope.importCalendar = function (e) {

            $scope.file = e.files[0];

            if (!$scope.file) {
                return;
            }

            var ext = $scope.file.name.substr($scope.file.name.lastIndexOf('.') + 1).toLowerCase();

            if (ext !== 'xls' && ext !== 'xlsx') {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'Please upload an Excel file (.xls, .xlsx)',
                    timeout: 3000
                });
                return;
            }

            LinePlanService.importCalendar(model.linePlanID, $scope.file)
                .then(function (response) {
                        clearFileSelect();

                        if (response.IsSuccessful) {

                            toaster.pop({
                                type: 'success',
                                title: 'Calendar Import Completed',
                                body: 'Refreshing current line plan data.',
                                timeout: 5000
                            });

                            $scope.linePlanCalendersForm.$setPristine();
                            $scope.linePlanCalendersForm.$setUntouched();

                            $state.reload();
                        }
                        else {
                            toaster.pop({
                                type: 'error',
                                title: 'Calendar Import Failed',
                                body: response.Message,
                                timeout: 5000
                            });
                        }
                    },
                    function (error) {
                        clearFileSelect();

                        toaster.pop({
                            type: 'error',
                            title: 'File Upload Error',
                            body: error || 'There was an error while uploading your file.',
                            timeout: 5000
                        });
                    });

        };

        function clearFileSelect() {
            model.importCalendar = {};
            document.getElementById('file0').value = null;
        }
    }
})();
